import loadable from "@loadable/component";

export const DateQuestion = loadable(() => import("./DateQuestion"), {
  resolveComponent: mod => mod.DateQuestion,
});
